<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'bcContest_submit' | translate}}</h4>
</div>

<div class="modal-body">
    <div class="data-value" *ngIf="program">
        <label>{{'bcContestStudent_lblProgram' | translate}}</label>
        <div>{{program}}</div>
    </div>

    <div class="mb-3" [innerHTML]="'bcContest_submitConfirm' | translate | safeHtml"></div>

    <app-alert level="warning">{{'bcContest_submitWarning' | translate}}</app-alert>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="close()" type="button" [disabled]="isSubmitting">{{'dialog_close' | translate}}</button>

    <button class="btn btn-primary" (click)="submit()" type="button" [disabled]="isSubmitting">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isSubmitting"></span>
        {{'bcContest_submitBtn' | translate}}
    </button>
</div>
